import { apiClient } from '../../../../v4/core/apiClient';
import { queryClient } from '../../../../v4/migration/queryClientSingleton';
import { myV1ActionEvent } from '../../../../v4/migration/actionAsEventMiddleware.connected';
import { myBookingApi } from '../../../api/booking/booking.api.connected';
import { createProductionApi } from '../../../api/production/production.api.http';
import { myErrorService } from '../../front/ErrorService/ErrorService.connected';
import { myMessageService } from '../../internal/MessageService/MessageService.connected';
import { myMetastructureMappingService } from '../../internal/MetastructureMappingService/MetastructureMappingService.connected';
import { createProductionService } from './ProductionService.impl';

export const myProductionService = createProductionService({
  api: createProductionApi({
    client: apiClient,
    services: { metastructureMappingService: myMetastructureMappingService }
  }),
  bookingApi: myBookingApi,
  queryClient,
  v1Event: myV1ActionEvent,
  services: {
    messageService: myMessageService,
    errorService: myErrorService
  }
});
